// Entry point for the SPA
import './src/main.ts';
console.log("Deskrow SPA initialized");